export interface OrderListEditAliveRequest {
  id: number
  editToken: string
}

export function OrderListEditAliveRequestToJSON(
  value: OrderListEditAliveRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    edit_token: value.editToken !== '' ? value.editToken : undefined
  }
}
